module.exports = __webpack_public_path__ + "img/flag-2.7ca26c9f.svg";